import React from 'react';

function TermsAndConditions() {
  return (
    <div style={{ maxWidth: '800px', margin: '20px auto', fontFamily: 'sans-serif' }}>
      <h1>Terms and Conditions</h1>
      <p>
        Welcome to <a href="https://yeezy-official.netlify.app/" target="_blank" rel="noopener noreferrer">
          https://yeezy-official.netlify.app/
        </a> (the “<strong>Website</strong>”). By accessing or using the Website, you agree to be bound by these
        Terms and Conditions (“<strong>Agreement</strong>”) and our Privacy Policy. If you do not agree with
        any part of this Agreement, please discontinue use of the Website.
      </p>

      <h2>1. Website Use</h2>
      <p>
        You represent that you are at least 18 years of age (or the age of majority in your jurisdiction)
        and have the legal capacity to form a binding contract. You agree to use the Website only for lawful
        purposes and in a manner consistent with all applicable local, state, national, and international laws
        and regulations.
      </p>

      <h2>2. Intellectual Property</h2>
      <p>
        All content, features, and functionality (including text, graphics, logos, and images) on the Website
        are the exclusive property of Kanye West or its licensors and are protected by copyright,
        trademark, and other applicable intellectual property laws. You may view, download, and print
        content from the Website solely for personal, non-commercial use.
      </p>

      <h2>3. Disclaimer of Warranties</h2>
      <p>
        The Website and its content are provided on an “as is” and “as available” basis without any warranties
        of any kind, whether express or implied. We do not warrant that the Website will be uninterrupted,
        error-free, secure, or free of viruses or other harmful components.
      </p>


      <h2>4. Third-Party Links</h2>
      <p>
        The Website may include links to third-party websites or services. These links are provided for your
        convenience, and we are not responsible for the content, privacy policies, or practices of any
        third-party websites.
      </p>

      <h2>5. Modifications</h2>
      <p>
        We reserve the right to modify these Terms and Conditions at any time. Any changes will be effective
        immediately upon posting on this page. Your continued use of the Website after any modifications
        indicates your acceptance of the revised Terms and Conditions.
      </p>



      <h2>6. Contact Us</h2>
      <p>
        If you have any questions about these Terms and Conditions, please contact us at:
        <br />
        <strong>Email:</strong> support@yeezy-official.com
      </p>
        <h2>6. Contact Us</h2>
      <p>
        If you have any questions about these Terms and Conditions, please contact us at:
        <br />
      </p>

      <p style={{ marginTop: '30px', fontStyle: 'italic',marginBottom: '230px' }}>
        Last Updated: [Feb 22, 2025]
      </p>
    </div>
  );
}

export default TermsAndConditions;